import { Clock } from "lucide-react";
import { useState, useEffect } from "react";

export default function App() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const countDownDate = new Date();
    countDownDate.setDate(countDownDate.getDate() + 30); // Set countdown to 30 days

    const updateCounter = () => {
      const now = new Date().getTime();
      const distance = countDownDate.getTime() - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    };

    updateCounter();
    const interval = setInterval(updateCounter, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(to bottom, #f0f0f0, #d0d0d0)",
        padding: "1rem",
        textAlign: "center",
      }}
    >
      {/* Media queries for responsive styling */}
      <style>{`
        @media (max-width: 480px) {
          .grid-timer {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
      `}</style>

      <div
        style={{
          maxWidth: "400px",
          margin: "0 auto",
          padding: "1.5rem",
          border: "1px solid #ccc",
          borderRadius: "8px",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ margin: "0 auto", width: "160px" }}>
          <img
            src="/logo.png?height=80&width=160"
            width={160}
            height={80}
            alt="Company Logo"
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        <div style={{ marginTop: "1rem" }}>
          <h1 style={{ fontSize: "2rem", fontWeight: "bold", margin: "0.5rem 0" }}>
            We're Under Maintenance
          </h1>
          <p style={{ color: "#666", fontSize: "0.9rem" }}>
            Our website is currently undergoing scheduled maintenance. We'll be back online shortly with a fresh new look!
          </p>
        </div>

        <div
          className="grid-timer"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "0.5rem",
            padding: "1rem 0",
          }}
        >
          {[
            { label: "Days", value: timeLeft.days },
            { label: "Hours", value: timeLeft.hours },
            { label: "Minutes", value: timeLeft.minutes },
            { label: "Seconds", value: timeLeft.seconds },
          ].map(({ label, value }) => (
            <div
              key={label}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "1px solid #ccc",
                background: "#fafafa",
                padding: "0.5rem",
                borderRadius: "4px",
              }}
            >
              <span style={{ fontSize: "1.25rem", fontWeight: "bold" }}>{value}</span>
              <span style={{ fontSize: "0.75rem", color: "#666" }}>{label}</span>
            </div>
          ))}
        </div>

     
        <div
          style={{
            marginTop: "1rem",
            borderTop: "1px solid #ccc",
            paddingTop: "0.75rem",
            fontSize: "0.85rem",
            color: "#666",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}>
            <Clock style={{ height: "16px", width: "16px" }} />
            <p style={{ margin: 0 }}>We'll be back online soon</p>
          </div>
          <div style={{ marginTop: "0.5rem" }}>
            <p style={{ margin: "0.25rem 0" }}>Email: contact@lebrewking.com</p>
            <p style={{ margin: "0.25rem 0" }}>Tollfree: 18003092847</p>
          </div>
        </div>
      </div>
    </div>
  );
}
